import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import GameCard from "../components/GameCard";

const MyGames = () => {
  const [trackedGames, setTrackedGames] = useState([]);
  const [wishlistedGames, setWishlistedGames] = useState([]);
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    // If not authenticated, redirect to home page
    if (!isAuthenticated || !user?.id) {
      navigate('/');
      return;
    }

    // Load user's games
    api.get(`/my-games/${user.id}`)
      .then((res) => {
        const allGames = res.data;
        
        // Transform data to match GameCard component expectations
        const transformGameData = (game) => ({
          id: game.game_id,
          title: game.name,
          cover: game.coverUrl || "/StockGameCover.jpg",
          releaseDate: game.first_release_date ? new Date(game.first_release_date * 1000).toLocaleDateString() : 'TBA',
          releaseDateUnix: game.first_release_date,
          summary: game.storyline || "No description available.",
          trailerUrl: game.trailerUrl ? game.trailerUrl.replace('watch?v=', 'embed/') : null,
          rating: game.aggregated_rating ? (game.aggregated_rating / 10).toFixed(1) : null,
          ratingCount: game.rating_count || null,
          steamUrl: game.steam_url || null
        });

        setTrackedGames(allGames.filter(g => g.tracking).map(transformGameData));
        setWishlistedGames(allGames.filter(g => g.wishlist).map(transformGameData));
      })
      .catch((err) => {
        console.error("Failed to load your games:", err);
      });
  }, [navigate, user, isAuthenticated]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">My Games</h1>
      
      {/* Tracked Games */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Tracked Games</h2>
        {trackedGames.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 justify-items-center max-w-7xl mx-auto">
            {trackedGames.map(game => (
              <div key={game.id} className="relative group w-full max-w-xs">
                <GameCard 
                  game={game}
                  variant="light"
                  showRating={true}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No tracked games yet.</p>
        )}
      </section>

      {/* Wishlisted Games */}
      <section>
        <h2 className="text-2xl font-semibold mb-4">Wishlisted Games</h2>
        {wishlistedGames.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 justify-items-center max-w-7xl mx-auto">
            {wishlistedGames.map(game => (
              <div key={game.id} className="relative group w-full max-w-xs">
                <GameCard 
                  game={game}
                  variant="light"
                  showRating={true}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No wishlisted games yet.</p>
        )}
      </section>
    </div>
  );
};

export default MyGames;
